// src/pages/admin/AddBook.jsx
import React, { useState } from 'react';
import { db, storage } from '../../services/firebase';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';

const AddBook = () => {
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [genre, setGenre] = useState('');
  const [pages, setPages] = useState('');
  const [imageOption, setImageOption] = useState('upload'); // 'upload' or 'url'
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !author || !price) {
      alert('Please fill required fields: Title, Author, Price');
      return;
    }

    setLoading(true);

    try {
      let finalImageUrl = '';

      if (imageOption === 'upload' && imageFile) {
        // Upload file to Firebase Storage
        const imageRef = ref(storage, `books/${Date.now()}_${imageFile.name}`);
        await uploadBytes(imageRef, imageFile);
        finalImageUrl = await getDownloadURL(imageRef);
      } else if (imageOption === 'url' && imageUrl.trim()) {
        // Use direct URL from web (no upload needed)
        finalImageUrl = imageUrl.trim();
      } else {
        alert('Please provide a book cover image (upload or URL)');
        setLoading(false);
        return;
      }

      await addDoc(collection(db, "books"), {
        title: title.trim(),
        author: author.trim(),
        price: parseFloat(price),
        description: description.trim(),
        genre: genre.trim(),
        pages: pages ? parseInt(pages) : null,
        language: "Nepali",
        rating: 4.5,
        imageUrl: finalImageUrl,
        createdAt: new Date()
      });

      alert("Book added successfully!");
      navigate('/admin/books');
    } catch (error) {
      console.error("Error adding book:", error);
      alert("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto', padding: '20px' }}>
      <h1>Add New Book</h1>

      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '20px' }}>
        <input
          type="text"
          placeholder="Book Title (e.g. Muna Madan)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Author (e.g. Laxmi Prasad Devkota)"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          required
        />

        <input
          type="number"
          step="0.01"
          placeholder="Price in CAD (e.g. 19.99)"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
        />

        <textarea
          placeholder="Description / Summary"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows="5"
        />

        <input
          type="text"
          placeholder="Genre (e.g. Fiction, Poetry-Novel, Classic)"
          value={genre}
          onChange={(e) => setGenre(e.target.value)}
        />

        <input
          type="number"
          placeholder="Number of Pages (optional)"
          value={pages}
          onChange={(e) => setPages(e.target.value)}
        />

        {/* Image Option Selector */}
        <div>
          <h3>Book Cover Image *</h3>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ marginRight: '20px' }}>
              <input
                type="radio"
                value="upload"
                checked={imageOption === 'upload'}
                onChange={(e) => setImageOption(e.target.value)}
              />
              {' '}Upload from computer
            </label>
            <label>
              <input
                type="radio"
                value="url"
                checked={imageOption === 'url'}
                onChange={(e) => setImageOption(e.target.value)}
              />
              {' '}Paste image link from website
            </label>
          </div>

          {imageOption === 'upload' ? (
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImageFile(e.target.files[0])}
            />
          ) : (
            <div>
              <input
                type="url"
                placeholder="https://example.com/book-cover.jpg"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                style={{ width: '100%', padding: '10px' }}
              />
              <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '5px' }}>
                Tip: Right-click an image online → "Copy image address" → paste here.
              </p>
            </div>
          )}
        </div>

        <button
          type="submit"
          className="button"
          disabled={loading}
          style={{ padding: '15px', fontSize: '1.1rem' }}
        >
          {loading ? 'Adding Book...' : 'Add Book'}
        </button>
      </form>
    </div>
  );
};

export default AddBook;